    //  Acceessibility Fixes
    $(document).ready(function() {
      $('br').attr('aria-hidden','true');
      $('a[href="https://www.shopify.com?utm_campaign=poweredby&utm_medium=shopify&utm_source=onlinestore"]').attr('aria-label','Powered by Shopify, this link will open in a new tab');
      $('.product-gallery__thumbnails').removeAttr('tabindex');
      $('img[src="//www.grandparentgiftcompany.com/cdn/shop/files/IMG_0824sq_300x.jpg?v=1707245133"]').attr('alt','Two wrapped gift boxes one in ivory with a silver ribbon, the other in floral paper with a white ribbon');
      $('a[href="https://www.shopify.com/legal/cookies"]').attr('aria-label','https://www.shopify.com/legal/cookies, this link will open in a new tab');
      });
      
      $(document).ready(function() {
        setTimeout(function() {
          $('.modal_price.subtitle .price-ui span.price span.money').prepend('<span class="visually-hidden">Sale Price</span>');
      $('span.compare-at-price span.money').prepend('<span class="visually-hidden">Regular Price</span>');
      $('a[href="https://grandparent.cameoez.com/Scripts/PublicSite/?template=Login"]').attr('aria-label','Login to Wholesale Site, this link will open in a new tab');
        }, 2000); 
      });
          // Back To Top Button
      $(document).ready(function() {
          var backToTopButton = $('#back-to-top');
          
          $(window).scroll(function() {
              if ($(this).scrollTop() > 300) {
                  backToTopButton.show();
              } else {
                  backToTopButton.hide();
              }
          });
          
          backToTopButton.on('click', function(e) {
              e.preventDefault();
              $('html, body').animate({ scrollTop: 0 }, 'slow');
              
              setTimeout(function() {
                  $('#backtoheader').focus(); 
                   backToTopButton.focus(); 
              }, 600); 
          });
      });
          //  Accessible Accordion
      document.addEventListener('DOMContentLoaded', function () {
          const accordionButtons = document.querySelectorAll('.accordion-button');
        
          accordionButtons.forEach(button => {
            button.addEventListener('click', function () {
              const expanded = this.getAttribute('aria-expanded') === 'true' || false;
              this.setAttribute('aria-expanded', !expanded);
              
              const content = this.nextElementSibling;
              if (expanded) {
                content.hidden = true;
              } else {
                content.hidden = false;
              }
            });
          });
        });
          //  For Email Address Warning
      $(document).ready(function() {
        $('a[href="mailto:info@grandparentgiftco.com"],a[href="mailto:info@grandparentgiftcompany.com"]').each(function() {
            var originalTitle = $(this).text();
            
            var trimmedTitle = originalTitle.length > 40 ? originalTitle.substring(0, 40) + '' : originalTitle;
            
            // Add "email address" before the trimmedTitle in the aria-label
            $(this).attr('aria-label', 'Email Address: ' + trimmedTitle + ' (open in a new window)');
            
            $(this).attr('target', '_blank');
            $(this).removeAttr('title');
        });
      });
          //  For Phone Numbers
      $(document).ready(function() {
        $('a[href="tel:+1-770-619-3167"],a[href="tel:+17706193167"],a[href="tel:+1(770)619-3167"]').each(function() {
            var originalTitle = $(this).text();
            
            var trimmedTitle = originalTitle.length > 40 ? originalTitle.substring(0, 40) + '' : originalTitle;
            
            // Add "email address" before the trimmedTitle in the aria-label
            $(this).attr('aria-label', 'Phone Number: ' + trimmedTitle + ' (open in a new window)');
            
            $(this).attr('target', '_blank');
            $(this).removeAttr('title');
        });
      });
      $(document).ready(function() {
        $('a.featured-article--link').each(function(index) {
            var trimmedText = $.trim($(this).text());
      
            var ariaLabelText = "Read more about" + trimmedText;
      
            $('.blog-card__read-more.buttons a.button.button--primary').eq(index).attr('aria-label', ariaLabelText);
        });
      });
           // Delay Query
      

// search focus

//svg on blogs
document.querySelectorAll('.accordion-icon').forEach(icon => {
    icon.setAttribute('aria-hidden', 'true');
});


 $( document ).ready(function() {
      //wait until the last element (#checkout-step-shipping_method) being rendered
      var existCondition = setInterval(function() {
       if ($('.instafeed-new-layout-item').length) { 
        clearInterval(existCondition);
        runMyFunction2();
       }
      }, 200);

      function runMyFunction2(){
       console.log("Customer Email Laoding");
	$('.instafeed-new-layout-item a').append('<span class="visually-hidden">this link will open in new tab</span>');
      }
    }); 

      $(document).ready(function() {
        $('a[href="http://www.ecomback.com/"],a[href="https://www.ada.gov/2010_regs.htm"],a[href="https://www.w3.org/WAI/"],a[href="https://www.w3.org/TR/WCAG21/"],a[href="https://support.apple.com/guide/mac-help/get-started-with-accessibility-features-mh35884/mac"],a[href="https://about.google/belonging/disability-inclusion/product-accessibility/"],a[href="https://support.mozilla.org/en-US/kb/keyboard-shortcuts-perform-firefox-tasks-quickly"],a[href="https://support.microsoft.com/en-us/microsoft-edge/accessibility-features-in-microsoft-edge-4c696192-338e-9465-b2cd-bd9b698ad19a#ID0EBBD=Windows"],a[href="https://www.nvaccess.org/download/"],a[href="https://www.ecomback.com/accessibility-shortcuts-guide-for-screen-readers-and-browsers"],a[href="https://grandparent.cameoez.com/Scripts/PublicSite/?template=Login"],a[href="https://grandparent.cameoez.com/Scripts/PublicSite/index.php?userid=&template=Catalogs"],a[href="https://www.google.com/maps?ll=34.094862,-84.24335&z=7&t=m&hl=en&gl=US&mapclient=embed&cid=18366540655317422985"],a[href="https://www.shopify.com/legal/cookies"],a[href="https://privacy.shopify.com/en"]').each(function() {
            var originalTitle = $(this).text();
            
            var trimmedTitle = originalTitle.length > 40 ? originalTitle.substring(0, 40) + '' : originalTitle;
            
            
            $(this).attr('target', '_blank');
            $(this).removeAttr('title');
        });
      });
